import React from 'react';
import { Card, Button, Alert, Row, Col } from 'react-bootstrap';

const PaymentSuccess = ({ registrationData, paymentData, onNewRegistration }) => {
  return (
    <Card className="shadow">
      <Card.Header className="bg-success text-white text-center">
        <h3>Payment Successful!</h3>
      </Card.Header>
      <Card.Body className="text-center">
        <div className="mb-4">
          <i className="fas fa-check-circle text-success" style={{ fontSize: '4rem' }}></i>
          <h4 className="mt-3">Thank you, {registrationData.name}!</h4>
          <p className="text-muted">Your registration and payment have been confirmed.</p>
        </div>
        
        <Row>
          <Col md={6}>
            <strong>Registration ID:</strong>
            <p>{registrationData.id}</p>
          </Col>
          <Col md={6}>
            <strong>Payment ID:</strong>
            <p>{paymentData.paymentId}</p>
          </Col>
        </Row>
        
        <Row>
          <Col md={6}>
            <strong>Amount Paid:</strong>
            <p className="text-success">₹{registrationData.fee}</p>
          </Col>
          <Col md={6}>
            <strong>Payment Status:</strong>
            <p className="text-success">{paymentData.status}</p>
          </Col>
        </Row>
        
        <Row>
          <Col md={6}>
            <strong>Email:</strong>
            <p>{registrationData.email}</p>
          </Col>
          <Col md={6}>
            <strong>Date:</strong>
            <p>{new Date().toLocaleDateString()}</p>
          </Col>
        </Row>

        <Alert variant="info" className="mt-4">
          <strong>What's Next:</strong>
          <ul className="text-start mt-2">
            <li>Save your Registration ID: <strong>{registrationData.id}</strong></li>
            <li>Save your Payment ID: <strong>{paymentData.paymentId}</strong></li>
            <li>A confirmation email will be sent to your registered email address</li>
            <li>Keep this confirmation for your records</li>
            <li>You will receive further details about the symposium via email</li>
          </ul>
        </Alert>

        <Alert variant="success" className="mt-3">
          <strong>NSDSST 2025 Registration Complete!</strong>
          <br />
          <small>National Symposium on Dielectric Spectroscopy in Science and Technology</small>
          <br />
          <small>October 31st, 2025 | S.R.T.M. University, Nanded</small>
        </Alert>

        <Button 
          variant="primary" 
          onClick={onNewRegistration}
          className="mt-3"
          size="lg"
        >
          Register Another Participant
        </Button>
      </Card.Body>
    </Card>
  );
};

export default PaymentSuccess;
